/**
  AGV路由配置
*/

// import MoveKu from '@/pages/MoveKu/index';
// import Details from '@/pages/MovekuDetail/index';
// import MovekuFind from '@/pages/MovekuFind/index';
// import MovekuStep from '@/pages/MovekuStep/index';
// import MovekuAbnor from '@/pages/MovekuAbnor/index';
// import Inventory from '@/pages/Inventory/index';
// import InventoryAdd from '@/pages/InvenToryadd/index';
// import InvenToryDetail from '@/pages/InvenToryDetail/index';
// import InventoryFind from '@/pages/InventoryFind/index';
// import InventoryStep from '@/pages/InvenToryStep/index';
// import InvenToryChart from '@/pages/InvenToryChart/index';
// import RepleNish from '@/pages/RepleNish/index';
// import RepleSku from '@/pages/RepleSku';
// import RepleZhouList from '@/pages/RepleZhou/index';
// import RepleZhouDetail from '@/pages/RepleZhouDetail';
// import RepleTask from '@/pages/RepleTask/index';
// import RepleTaskDetail from '@/pages/RepleTaskDetail/index';
// import RepleDetailed from '@/pages/RepleDetailed/index';
// import RepleStep from '@/pages/RepleStep/index';
// import RepleAbnor from '@/pages/RepleAbnor/index';
// import Abcadmin from '@/pages/AbcAdmin/index';
// import AbcadminSku from '@/pages/AbcAdminSku/index';
// import RepleAbc from '@/pages/RepleAbc/index';
// import DevanningQueryList from '@/pages/DevanningQueryList/index';
// import DevanningQueryDetailList from '@/pages/DevanningQueryDetailList/index';
// import DevanningQueryDetail from '@/pages/DevanningQueryDetail/index';
import React from 'react';

export default [
  {
    path: '/inside/MoveKu/list',
    // component: MoveKu,
    component: React.lazy(() => import(/* webpackChunkName: 'MoveKu' */ '@/pages/MoveKu/index')),
  },
  {
    path: '/inside/MovekuDetail/detail/:jobNo',
    // component: Details,
    component: React.lazy(() => import(/* webpackChunkName: 'Details' */ '@/pages/MovekuDetail/index')),
  },
  {
    path: '/inside/MoveKu/movekuFind',
    // component: MovekuFind,
    component: React.lazy(() => import(/* webpackChunkName: 'MovekuFind' */ '@/pages/MovekuFind/index')),
  },
  {
    path: '/inside/MoveKu/movekuStep',
    // component: MovekuStep,
    component: React.lazy(() => import(/* webpackChunkName: 'MovekuStep' */ '@/pages/MovekuStep/index')),
  },
  {
    path: '/inside/MoveKu/movekuAbnor',
    // component: MovekuAbnor,
    component: React.lazy(() => import(/* webpackChunkName: 'MovekuAbnor' */ '@/pages/MovekuAbnor/index')),
  },
  {
    path: '/inside/Inventory/list',
    // component: Inventory,
    component: React.lazy(() => import(/* webpackChunkName: 'Inventory' */ '@/pages/Inventory/index')),
  },
  {
    path: '/inside/Inventory/InventoryAdd',
    // component: InventoryAdd,
    component: React.lazy(() => import(/* webpackChunkName: 'InventoryAdd' */ '@/pages/InvenToryadd/index')),
  },
  {
    path: '/inside/Inventory/InvenToryDetail/:tid',
    // component: InvenToryDetail,
    component: React.lazy(() => import(/* webpackChunkName: 'InvenToryDetail' */ '@/pages/InvenToryDetail/index')),
  },
  {
    path: '/inside/Inventory/InventoryFind',
    // component: InventoryFind,
    component: React.lazy(() => import(/* webpackChunkName: 'InventoryFind' */ '@/pages/InventoryFind/index')),
  },
  {
    path: '/inside/Inventory/InventoryStep',
    // component: InventoryStep,
    component: React.lazy(() => import(/* webpackChunkName: 'InventoryStep' */ '@/pages/InvenToryStep/index')),
  },
  {
    path: '/inside/Inventory/InvenToryChart',
    // component: InvenToryChart,
    component: React.lazy(() => import(/* webpackChunkName: 'InvenToryChart' */ '@/pages/InvenToryChart/index')),
  },
  {
    path: '/inside/replenish/replesku',
    // component: RepleSku,
    component: React.lazy(() => import(/* webpackChunkName: 'RepleSku' */ '@/pages/RepleSku')),
  },
  {
    path: '/inside/replenish/repletask',
    // component: RepleTask,
    component: React.lazy(() => import(/* webpackChunkName: 'RepleTask' */ '@/pages/RepleTask/index')),
  },
  {
    path: '/inside/replenish/repletaskdetail/:tid',
    // component: RepleTaskDetail,
    component: React.lazy(() => import(/* webpackChunkName: 'RepleTaskDetail' */ '@/pages/RepleTaskDetail/index')),
  },
  {
    path: '/inside/replenish/repleDetailed',
    // component: RepleDetailed,
    component: React.lazy(() => import(/* webpackChunkName: 'RepleDetailed' */ '@/pages/RepleDetailed/index')),
  },
  {
    path: '/inside/replenish/repleStep',
    // component: RepleStep,
    component: React.lazy(() => import(/* webpackChunkName: 'RepleStep' */ '@/pages/RepleStep/index')),
  },
  {
    path: '/inside/replenish/repleAbnor',
    // component: RepleAbnor,
    component: React.lazy(() => import(/* webpackChunkName: 'RepleAbnor' */ '@/pages/RepleAbnor/index')),
  },
  {
    path: '/inside/abcadmin/list',
    // component: Abcadmin,
    component: React.lazy(() => import(/* webpackChunkName: 'Abcadmin' */ '@/pages/AbcAdmin/index')),
  },
  {
    path: '/inside/abcadmin/abcadminSku',
    // component: AbcadminSku,
    component: React.lazy(() => import(/* webpackChunkName: 'AbcadminSku' */ '@/pages/AbcAdminSku/index')),
  },
  {
    path: '/inside/replenish/repleAbc',
    // component: RepleAbc,
    component: React.lazy(() => import(/* webpackChunkName: 'RepleAbc' */ '@/pages/RepleAbc/index')),
  },
  {
    path: '/inside/Devanning/list',
    // component: DevanningQueryList,
    component: React.lazy(
      () => import(/* webpackChunkName: 'DevanningQueryList' */ '@/pages/DevanningQueryList/index'),
    ),
  },
  {
    path: '/inside/Devanning/detailList',
    // component: DevanningQueryDetailList,
    component: React.lazy(
      () => import(/* webpackChunkName: 'DevanningQueryDetailList' */ '@/pages/DevanningQueryDetailList/index'),
    ),
  },
  {
    path: '/inside/Devanning/detailListDetail',
    // component: DevanningQueryDetail,
    component: React.lazy(
      () => import(/* webpackChunkName: 'DevanningQueryDetail' */ '@/pages/DevanningQueryDetail/index'),
    ),
  },
  {
    path: '/inside/Inventory/InventoryGenTask',
    // component: InventoryGenTask,
    component: React.lazy(() => import(/* webpackChunkName: 'InventoryGenTask' */ '@/pages/InventoryGenTask/index')),
  },
];
